import * as Cookies from 'js-cookie';
import HeroComponent from '../components/hero';
import YouTubeEmbedAPI from '../modules/YouTubeEmbedAPI';

export default class RecipeController {
  constructor(options) {
    this.options = options;
    console.log('RECIPE CONTROLLER');

    this.recipes_products = new HeroComponent({
      elem: 'section.recipe__product',
    });

    this.recipes_tips = new HeroComponent({
      elem: 'section.recipes__tips',
    });

    if($('.recipe_website_tips').length){$('.recipe_website_tips').html( $('.recipe_website_tips').html().replace( /(https?:\/\/[^\s]+)/g , '<a href="$1" target="_blank">$1</a>' ) )};

    $('.recipe__card__frontFlip>button').click( () => {
      $('div.recipe__card__cntr').addClass('is-flipped');
    });

    $('.recipe__card__backFlip>button').click( () => {
      $('div.recipe__card__cntr').removeClass('is-flipped');
    });

    $('nav.siteNav__main>div>a.submenu__recipes').addClass('is-activepage');

    $('.recipe__rating__cntr').click( () => {
      if ($('.recipe__rating__cntr')[0].className.indexOf('has-voted') === -1) {
        this.toggleRatingUI();
      }
    });

    this.YTE = new YouTubeEmbedAPI();

    $('.is-video').click( (e) => {
      console.log("is video")
      e.preventDefault();

      $('div.site__overlay').addClass('is-active');
      $('div.modal .modal__content').removeClass('dn');
      $('div.modal').addClass('is-active');

      const videoID = $(e.currentTarget).data('videoid');
      console.log(videoID, $(e.currentTarget));
      this.YTE.createPlayer(videoID);
    });

    $('div.modal').click( (e) => {

      if ( $(e.target).hasClass('modal') ||
        $(e.target).hasClass('modal__close') ) {

        $('div.site__overlay').removeClass('is-active');
        $('div.modal .modal__content').addClass('dn');
        $('div.modal').removeClass('is-active');

        if (this.YTE) {
          this.YTE.destroyPlayer();
        }
      }

    });

    // close the rating UI if tabbed out
    $('#last__rating__egg').blur( () => {
      this.closeRating();
    });

    $('.recipe__ratings__popout a').hover( (e) => {
      $( e.currentTarget ).addClass('recipe__rating--full');
      $( e.currentTarget ).removeClass('recipe__rating--none');
      $( e.currentTarget ).prevAll().removeClass('recipe__rating--none');
      $( e.currentTarget ).prevAll().addClass('recipe__rating--full');
    }, (e) => {
      $( e.currentTarget ).addClass('recipe__rating--none');
      $( e.currentTarget ).removeClass('recipe__rating--full');
      $( e.currentTarget ).prevAll().removeClass('recipe__rating--full');
      $( e.currentTarget ).prevAll().addClass('recipe__rating--none');
    });


    $('.recipe__ratings__popout a').click( (e) => {
      const link = $(e.currentTarget);
      const url = link.attr('href');
      const score = link.data('score');
      e.stopPropagation();
      e.preventDefault();

      $('.recipe__rating__input').fadeOut();
      $('.recipe__rating__response').addClass('is-active');

      $.ajax({
        type: 'POST',
        url,
        data: JSON.stringify({ score }),
        dataType: 'json',
        headers: {
          'X-CSRFToken': Cookies.get('csrftoken'),
        },
      }).done( () => {
        setTimeout( () => {
          $('.recipe__ratings__popout').on('transitionend', () => {
            $('.recipe__rating__input').fadeIn();
            $('.recipe__rating__response').removeClass('is-active');
            $('.recipe__ratings__popout').off('transitionend');
          });
          $('.recipe__rating__cntr').off('click');
          $('.recipe__rating__cntr').addClass('has-voted');
          $('.recipe__rating__cntr>em').data('close', '');
          this.closeRating();
          setTimeout( () => {
            location.reload();
          }, 500);
        }, 1200);
      }).fail( () => {
        console.error('Rating service failure.');
      });
    });


    setTimeout( () => {
      $('section.cmpnt__recipe>div.u-cntr').addClass('is-active');
      $('.related-recipes>div.u-cntr').addClass('is-active');
    }, 300 );

  }

  toggleRatingUI() {

    if ( $('.recipe__rating__cntr').hasClass('is-active') ) {
      this.closeRating();
    } else {
      this.openRating();
    }

  }

  openRating() {
    $('.recipe__ratings__popout').addClass('is-active');
    $('.recipe__rating__cntr').addClass('is-active');
    $('.recipe__rating__cntr>em').text($('.recipe__rating__cntr>em').data('open'));
  }

  closeRating() {
    $('.recipe__ratings__popout').css('visibility', 'visible');
    $('.recipe__ratings__popout').removeClass('is-active');
    $('.recipe__rating__cntr').removeClass('is-active');
    $('.recipe__rating__cntr>em').text( $('.recipe__rating__cntr>em').data('close') );

    setTimeout( () => {
      $('.recipe__ratings__popout').css('visibility', '');
    }, 500);
  }

  handleResize() {
  }

  handleScroll() {
  }
}



// WEBPACK FOOTER //
// ./js/controllers/pages/RecipeController.js